import { z } from 'zod'

export const EditAppointmentProtocolSchema = z.object({
	appointments: z.array(
		z.object({
			quantity: z.number().min(1),
			specialtyId: z.string(),
			serviceProviderId: z.string().optional(),
		})
	),
})
